import React from 'react';
import { Icon } from '../Icon';
import { useIntersectionTracking } from '../../shared/use-intersection-tracking';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import styles from './CancelAnytimeBlock.css';

function CancelAnytimeBlock() {
    useIntersectionTracking(`#${EVENT_TYPES.CANCEL_ANYTIME_BLOCK_VIEWED}`);

    return (
        <div className={styles.cancelAnytimeBlock} id={EVENT_TYPES.CANCEL_ANYTIME_BLOCK_VIEWED}>
            <div className={styles.cancelAnytimeHeader}>
                <div className={styles.cancelAnytimeIconWrapper}>
                    <Icon name='checked-2' className={styles.cancelAnytimeCheckIcon} />
                </div>
                <div>
                    <p className={styles.cancelAnytimeTitle}>Cancel anytime</p>
                    <p className={styles.cancelAnytimeSubtitle}>
                        Cancel in 2 taps from your profile
                    </p>
                </div>
            </div>
        </div>
    );
}

export {
    CancelAnytimeBlock
};
